import React from 'react';
import './ValidationErrorBanner.css';

interface Props {
  errors: string[];
  invalidFields: string[];
  onClose?: () => void;
}


const fieldNameMap: Record<string, string> = {
  NumberItems: 'Número de sabores',
  MaximumItems: 'Máximo de ingredientes por sabor',
  MinimumPrice: 'Preço mínimo de venda',
  TabletTerminals: 'Terminais de Tablet',
  SellingRules: 'Regras de Venda',
  NumberFreetems: 'Número de extras grátis',
  NumberFreelngredients: 'Número de ingredientes grátis',
};

export const ValidationErrorBanner: React.FC<Props> = ({ errors, invalidFields, onClose }) => {
  if (errors.length === 0) return null;

  const scrollToField = (fieldName: string) => {
    const element = document.querySelector(`[name="${fieldName}"]`);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'center' });
      // Focus no campo
      (element as HTMLElement).focus();
    }
  };

  return (
    <div className="validation-error-banner">
      <div className="banner-header">
        <div className="banner-title">
          <span className="error-icon">⚠️</span>
          <h3>Atenção! Corrija os campos abaixo:</h3>
        </div>
        {onClose && (
          <button 
            type="button" 
            className="close-button" 
            onClick={onClose}
            aria-label="Fechar"
          >
            ✕
          </button>
        )}
      </div>
      
      <div className="banner-content">
        <p className="banner-subtitle">
          {invalidFields.length} {invalidFields.length === 1 ? 'campo precisa' : 'campos precisam'} ser corrigido
          {invalidFields.length !== 1 ? 's' : ''}:
        </p>
        
        <ul className="error-list">
          {invalidFields.map((fieldName, index) => (
            <li key={fieldName}>
              <button
                type="button"
                className="field-link"
                onClick={() => scrollToField(fieldName)}
              >
                <span className="field-number">{index + 1}.</span>
                <span className="field-name">{fieldNameMap[fieldName] || fieldName}</span>
                <span className="go-to-field">→</span>
              </button>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};